export enum LoginTypeEnum {
  OAUTH = 'OAUTH',
  SAML = 'SAML',
  CLASSIC = 'CLASSIC',
  FACEBOOK = 'FACEBOOK',
  PIM = 'PIM',
}

export const SSOLoginTypes = [LoginTypeEnum.OAUTH];
